import React from 'react';
import { Alert, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

type Props = { executive?: any; loading?: boolean; onSubmit: (notes: string) => void; onApprove: (notes: string) => void; onOpenDeterminantBudget: () => void };
type State = { notes: string };

class SimulationPublishPanel extends React.Component<Props, State> {
  state: State = { notes: '' };
  render() {
    const d = this.props.executive || {};
    const checks = d.checks || {};
    const approved = d.statecode === 'APPROVED';
    return (
      <Stack spacing={2}>
        <Alert severity={approved ? 'success' : 'warning'}>Determinant Budget publication is controlled. Submit and approve the simulation before generating the determinant budget.</Alert>
        <Paper elevation={1} sx={{ p: 2 }}><Typography variant="h6" sx={{ fontWeight: 800 }}>Readiness Checklist</Typography><Grid container spacing={1} sx={{ mt: 1 }}>{['Historical Data', 'Forecast Baseline', 'Assumptions', 'Simulation', 'Constraints', 'Capacity'].map((x) => <Grid size={{ xs: 12, md: 4 }} key={x}><Alert severity={checks.ready ? 'success' : 'info'}>{x}</Alert></Grid>)}</Grid></Paper>
        <TextField label="Review / Approval Notes" value={this.state.notes} onChange={(e) => this.setState({ notes: e.target.value })} multiline minRows={3} fullWidth />
        <Stack direction="row" spacing={1} flexWrap="wrap">
          <Button variant="outlined" startIcon={<SendIcon />} onClick={() => this.props.onSubmit(this.state.notes)} disabled={this.props.loading}>Submit for Review</Button>
          <Button variant="outlined" color="success" startIcon={<CheckCircleIcon />} onClick={() => this.props.onApprove(this.state.notes)} disabled={this.props.loading}>Approve Simulation</Button>
          <Button variant="contained" startIcon={<AccountTreeIcon />} onClick={this.props.onOpenDeterminantBudget} disabled={!approved || this.props.loading}>Open Determinant Budget</Button>
        </Stack>
      </Stack>
    );
  }
}
export default SimulationPublishPanel;
